import _ from 'lodash'

export default ({
  currentUser: {
    sites,
  },
}) => ({
  group: {
    site: {
      id,
    },
  },
}) => {
  if (id === null) return false

  return !_.some(sites, { id })
}
